import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoWhiteShort = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "22px",
	height: "29px",
	viewBox: "0 0 22 29",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Group" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Page-1",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "iPhone-11-Pro",
				transform: "translate(-69.000000, -267.000000)",
				fill: "#FFFFFF",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "Group",
					transform: "translate(69.000000, 267.960938)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "M11.3891,0.139702079 C11.1142,0.366222079 11.1142,0.790312079 11.1142,1.63848208 L11.1142,19.1228621 C11.1142,19.7170621 11.1142,20.0141621 11.286,20.2230621 C11.4578,20.4320621 11.7493,20.4895621 12.3323,20.6044621 L13.9116,20.9158621 C14.7457,21.0803621 15.1627,21.1625621 15.4383,20.9360621 C15.7139,20.7094621 15.7139,20.2843621 15.7139,19.4342621 L15.7139,1.94575208 C15.7139,1.35015208 15.7139,1.05235208 15.5415,0.843182079 C15.3691,0.634012079 15.0768,0.577142079 14.4921,0.463402079 L12.9128,0.156142079 C12.0802,-0.00583092131 11.6639,-0.0868169213 11.3891,0.139702079 Z",
							id: "Path"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M16.7379,7.89022208 C16.7379,7.04563208 16.7379,6.62334208 17.0114,6.39687208 C17.2848,6.17040208 17.6997,6.24912208 18.5295,6.40656208 L20.1089,6.70622208 C20.6966,6.81773208 20.9905,6.87349208 21.164,7.08302208 C21.3375,7.29256208 21.3375,7.59167208 21.3375,8.18989208 L21.3375,15.4865621 C21.3375,16.3311621 21.3375,16.7534621 21.064,16.9799621 C20.7906,17.2063621 20.3757,17.1276621 19.5459,16.9702621 L17.9665,16.6705621 L17.9665,16.6705621 C17.3788,16.5590621 17.0849,16.5032621 16.9114,16.2937621 C16.7379,16.0842621 16.7379,15.7851621 16.7379,15.1868621 L16.7379,7.89022208 Z",
							id: "Path"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M-1.64313008e-14,9.63836208 C-1.64313008e-14,8.81086208 -1.64313008e-14,8.39713208 0.266989,8.17094208 C0.533978,7.94475208 0.94208,8.01273208 1.75829,8.14870208 L3.20988,8.39052208 C3.8126,8.49092208 4.11396,8.54112208 4.29292,8.75236208 C4.47187,8.96359208 4.47187,9.26906208 4.47187,9.88016208 L4.47187,17.1382621 C4.47187,17.9868621 4.47187,18.4111621 4.19687,18.6377621 C3.92186,18.8642621 3.5054,18.7829621 2.67247,18.6204621 L1.22088,18.3371621 C0.63664,18.2231621 0.344519,18.1660621 0.172259,17.9569621 C-1.64313008e-14,17.7478621 -1.64313008e-14,17.4502621 -1.64313008e-14,16.8549621 L-1.64313008e-14,9.63836208 Z",
							id: "Path"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M5.4953,15.8342621 C5.4953,14.9803621 5.4953,14.5533621 5.77227,14.3268621 C6.04925,14.1002621 6.46773,14.1848621 7.30468,14.3540621 L7.30469,14.3540621 L7.3047,14.3540621 L8.88406,14.6733621 C9.46379,14.7905621 9.75365,14.8491621 9.92429,15.0577621 C10.0949,15.2663621 10.0949,15.5621621 10.0949,16.1535621 L10.0949,25.9817621 C10.0949,26.8187621 10.0949,27.2372621 9.82432,27.4636621 C9.5537,27.6899621 9.14179,27.6160621 8.31796,27.4681621 L6.7386,27.1846621 L6.73858,27.1845621 C6.14426,27.0779621 5.8471,27.0245621 5.6712,26.8142621 C5.4953,26.6039621 5.4953,26.3020621 5.4953,25.6982621 L5.4953,15.8342621 Z",
							id: "Path"
						})
					]
				})
			})
		})
	]
});
export default SvgLogoWhiteShort;
